// SETTINGS ACTION
export const DOCUMENT_TO_LLM = 'DOCUMENT_TO_LLM';
export const SLIDE_TO_LLM="SLIDE_TO_LLM"
export const SLIDES_TO_LLM_IN_PROGRESS="SLIDES_TO_LLM_IN_PROGRESS"
export const SLIDES_TO_LLM_RESPONSE='SLIDES_TO_LLM_RESPONSE';
export const RESET_SLIDES_2_VIDEO='RESET_SLIDES_2_VIDEO'
export const SELECT_SLIDE="SELECT_SLIDE";
export const UPDATE_SLIDES="UPDATE_SLIDES";
